import { Paper, PaperProps, styled, Tooltip, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";

import { CoBenefitTypeAndChart, CostBenefitTypeAndChart } from "types/types";

import { Graph } from "components/result/resultGraphs/Graph";
import { Info } from "@mui/icons-material";
import { StyledMarkdown } from "components/utils/StyledMarkdown";

interface Props extends PaperProps {
  coBenefits: CoBenefitTypeAndChart;
  costs: CostBenefitTypeAndChart;
}

export function CostBenefitsGraphs(props: Props) {
  const { costs, coBenefits, ...paperProps } = props;
  const { t } = useTranslation();

  return (
    <StyledPaper {...paperProps}>
      <Typography variant="h2" component="h2">
        {t("label.costs")}
      </Typography>
      {costs.costBenefits.map((costBenefit) => (
        <Paper
          className="cost-graph"
          elevation={0}
          key={costBenefit.costBenefit.id}
        >
          <div className="header">
            <Typography variant="subtitle2" component="h3">
              {costBenefit.costBenefit.name}
            </Typography>
            <Tooltip
              color="primary"
              title={
                <StyledMarkdown content={costBenefit.costBenefit.description} />
              }
            >
              <Info />
            </Tooltip>
          </div>

          <Graph
            chartData={costBenefit.chartData}
            graphWidth="100%"
            graphMaxHeight="100px"
            graphHeight="100%"
          />
        </Paper>
      ))}
      <div className="header">
        <Typography variant="h2" component="h2">
          {t("label.coBenefits")}
        </Typography>
        <Tooltip
          color="primary"
          title={<StyledMarkdown content={coBenefits.description} />}
        >
          <Info />
        </Tooltip>
      </div>
      <Graph
        chartData={coBenefits.chartData}
        graphWidth="100%"
        graphHeight="100%"
      />
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  .cost-graph {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1)};
  }
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
  }
`;
